import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../../../contexts/CartContext";
import { AuthContext } from "../../../contexts/AuthContext";
import UserSVG from "../../../assets/images/icons/user.svg";
import Logo from "../../../assets/images/logo.png";
import Cart from "../../../assets/images/icons/cart.svg";

export default function HeaderBottom() {
  const { cartItems } = React.useContext(CartContext);
  const { handleLogout } = React.useContext(AuthContext);

  const { user } = useContext(AuthContext);
  return (
    <>
      <div className="ec-header-bottom  d-lg-block">
        <div className="container position-relative">
          <div className="row">
            <div className="header-bottom-flex">
              {/* Ec Header Logo Start */}
              <div className="align-self-center ec-header-logo ">
                <div className="header-logo">
                  <Link to="/">
                    <img
                      src={Logo}
                      alt="Prince art exporter"
                      height={60}
                      width={60}
                    />
                    <img
                      className="dark-logo"
                      src={Logo}
                      alt="Prince art exporter"
                      style={{ display: "none" }}
                    />
                  </Link>
                </div>
              </div>
              {/* Ec Header Logo End */}
              {/* Ec Header Search Start */}
              {/* <div className="align-self-center ec-header-search">
        <div className="header-search">
          <form className="ec-search-group-form" action="#">
            <div className="ec-search-select-inner">
              <select name="ec-search-cat">
                <option selected={true} disabled={true}>
                  All
                </option>
                <option value="cloths">Cloths</option>
                <option value="bag">Bag</option>
                <option value="shoes">Shoes</option>
              </select>
            </div>
            <input
              className="form-control"
              placeholder="I’m searching for..."
              type="text"
            />
            <button className="search_submit" type="submit">
              Search{" "}
              <img
                src="assets/images/icons/search.svg"
                className="svg_img search_svg"
                alt=""
              />
            </button>
          </form>
        </div>
      </div> */}
              {/* Ec Header Search End */}
              {/* Ec Header Button Start */}
              <div className="align-self-center ec-header-cart">
                <div className="ec-header-bottons">
                  {/* Header Cart Start */}
                  {user.userType === "Buyer" && (
                    <Link to="/cart" className="ec-header-btn ec-side-toggle">
                      <div className="header-icon">
                        <img src={Cart} className="svg_img header_svg" alt="" />
                      </div>
                      <span className="ec-header-count ec-cart-count">
                        {cartItems.length}
                      </span>
                      <span className="ec-btn-title">In Cart</span>
                    </Link>
                  )}

                  {/* Header Cart End */}
                  {/* Header User Start */}
                  <div className="ec-header-user dropdown">
                    <button
                      className="dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      <img
                        src={UserSVG}
                        className="svg_img header_svg"
                        alt=""
                      />
                      <span className="ec-btn-title">
                        {`${user.firstName} ${user.lastName}`}
                      </span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                      {user.userType != "Buyer" && (
                        <>
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/admin/dashboard"
                            >
                              Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to="/admin/change-password"
                            >
                              Change Password
                            </Link>
                          </li>
                        </>
                      )}

                      <li>
                        <Link
                          className="dropdown-item"
                          to=""
                          onClick={() => {
                            handleLogout();
                          }}
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* Header User End */}
                  {/* Header wishlist Start */}
                  {/* <a href="#" className="ec-header-btn ec-header-wishlist">
                    <div className="header-icon">
                      <img
                        src="assets/images/icons/wishlist.svg"
                        className="svg_img header_svg"
                        alt=""
                      />
                    </div>
                    <span className="ec-header-count ec-cart-wishlist">0</span>
                    <span className="ec-btn-title">wishlist</span>
                  </a> */}
                  {/* Header wishlist End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ec-header-bottom d-none">
        <div className="container position-relative">
          <div className="row ">
            {/* Ec Header Logo Start */}
            <div className="col">
              <div className="header-logo">
                <a href="index.html">
                  <img src={Logo} alt="Site Logo" />
                  <img
                    className="dark-logo"
                    src={Logo}
                    alt="Site Logo"
                    style={{ display: "none" }}
                  />
                </a>
              </div>
            </div>
            {/* Ec Header Logo End */}
          </div>
        </div>
      </div>
    </>
  );
}
